<script setup>
import { ref, computed } from 'vue'
import ChartView from '@/components/charts/ChartView.vue'
import DetailDrawer from '@/components/shell/DetailDrawer.vue'
import ChannelSend from '@/components/shell/ChannelSend.vue'
import { store } from '@/store/appStore.js'

const selectedCampaign = ref(null)
const showCreate = ref(false)
const blankForm = () => ({ campaignName:'', productSku:'', startDate:'2026-08-01', endDate:'2026-09-30', territories:[] })
const form = ref(blankForm())

const campaigns = computed(() => store.marketingV2.campaigns.value)
const active = computed(() => selectedCampaign.value || campaigns.value[0])
const products = store.marketingV2.products
const territories = store.marketingV2.territories
const canLaunch = computed(() => form.value.campaignName.trim() && form.value.productSku && form.value.territories.length)
const terrChart = computed(() => !active.value ? { labels:[], datasets:[] } : { labels:active.value.territoryPerformance.map(t=>t.territory), datasets:[{ label:'Performance Score', data:active.value.territoryPerformance.map(t=>t.performanceScore), backgroundColor:'#C99A2E' }] })

const toggleT = t => { const i=form.value.territories.indexOf(t); i>=0?form.value.territories.splice(i,1):form.value.territories.push(t) }
function launch() {
  if (!canLaunch.value) return
  const created = store.marketingV2.createCampaign({ ...form.value })
  if (created) { selectedCampaign.value = created; showCreate.value = false; form.value = blankForm() }
}
</script>
<template>
  <div>
    <div class="card module-header" style="display:flex;justify-content:space-between;align-items:flex-end;gap:12px;flex-wrap:wrap;">
      <h2>{{ campaigns.length }} campaigns tracked</h2>
      <button class="btn-primary" @click="showCreate=true">+ New Campaign</button>
    </div>
    <div class="card" style="margin-bottom:16px;">
      <div class="table-wrap"><table class="data-table"><thead><tr><th>Campaign</th><th>Product</th><th>Reach</th><th>Effectiveness</th><th>Adoption %</th></tr></thead>
        <tbody>
          <tr v-for="c in campaigns" :key="c.campaignName" class="clickable" @click="selectedCampaign=c">
            <td class="cell-strong">{{ c.campaignName }}</td><td>{{ c.productName }}</td>
            <td class="cell-muted">{{ c.reach.toLocaleString() }}</td><td class="cell-muted">{{ c.effectivenessScore }}</td><td class="cell-muted">{{ c.adoptionRate }}%</td>
          </tr>
        </tbody>
      </table></div>
    </div>

    <div v-if="active" class="card" style="padding:18px 20px;margin-bottom:16px;">
      <div class="eyebrow" style="margin-bottom:8px;">{{ active.campaignName }} — Territory Performance</div>
      <ChartView type="bar" :labels="terrChart.labels" :datasets="terrChart.datasets" :height="240" :key="'terr-'+active.campaignName" />
      <ChannelSend label="Notify pharmacies via" send-label="Send campaign" :recipient-description="active.territoryPerformance.length+' territories'" />
    </div>

    <DetailDrawer :open="showCreate" title="New Campaign" @close="showCreate=false">
      <div class="form-group"><label>Campaign Name</label><input class="form-input" v-model="form.campaignName" /></div>
      <div class="form-group">
        <label>Product</label>
        <select class="form-select" v-model="form.productSku">
          <option value="" disabled>Select…</option>
          <option v-for="p in products" :key="p.sku" :value="p.sku">{{ p.productName }}</option>
        </select>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
        <div class="form-group"><label>Start Date</label><input class="form-input" type="date" v-model="form.startDate" /></div>
        <div class="form-group"><label>End Date</label><input class="form-input" type="date" v-model="form.endDate" /></div>
      </div>
      <div class="form-group">
        <label>Territories</label>
        <div style="display:flex;flex-wrap:wrap;gap:6px;">
          <button v-for="t in territories" :key="t" class="filter-select" :style="form.territories.includes(t)?'background:var(--color-primary-dark);color:#fff;':'cursor:pointer;'" @click="toggleT(t)">{{ t }}</button>
        </div>
      </div>
      <button class="btn-primary" :disabled="!canLaunch" @click="launch">Launch Campaign</button>
    </DetailDrawer>
  </div>
</template>
